<template>
  <component
    :is="items.Component"
    v-slot:[slotType]
    v-model="defaultValue"
    v-bind="items.componentProps"
    v-on="items.on"
    v-if="items.prop"
  >
    <slot></slot>
  </component>
  <component
    :is="items.Component"
    v-slot:[slotType]
    v-bind="items.componentProps"
    v-on="items.on"
    v-else
  >
    <slot></slot>
  </component>
</template>
<script>
import { cloneDeep } from "lodash-unified";
export default {
  props: {
    items: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value:{
		}
  },
  computed: {
    slotType() {
      return this.items.slot || "default";
    },
    defaultValue: {
      get() {
				// console.log(this.value,'this.modelValue---')
        return cloneDeep(this.value);
      },
      set(news) {
        this.$emit("input", news);
      },
    },
  },
  data() {
    return {
    };
  },
  
};
</script>
<style lang="less" scoped></style>
